import { produce } from 'immer';
import { PINNED_STORAGE_KEY } from '../../constants';
import { initialResultsState } from '../state';
import { setBookmarkCount } from '../../utils/bookmark';
import {
  ADD_BOOKMARK_ITEM,
  BOOKMARKS_SET,
  REMOVE_BOOKMARK_ITEM,
  REMOVE_BOOKMARK_GROUP,
  REMOVE_FILTER,
  RESET_FILTERS,
  RESET_SELECTION,
  SET_ATTRIBUTES,
  SET_EXPANDED_CARD,
  SET_FILTER_PARAMS,
  SET_LOGIN_STATUS,
  SET_SELECTED,
  SET_TERM,
  UPDATE_STATE,
  UPDATE_TOAST,
  SET_AVAILABLE_FILTERS,
} from '../actions';

import { syncWithUrl } from './sync-with-url';

export const dfReducer = produce((draft, action) => {
  switch (action.type) {
    case UPDATE_STATE: {
      draft.results = action.results;
      draft.totalDownloads = action.totalDownloads || 0;
      draft.selectionAmount = action.selectionAmount;
      draft.countedCategories = action.countedCategories || [];
      draft.filterAttributes = action.filterAttributes || {
        fileTypes: [],
        languages: [],
      };
      draft.itemFilter = action.itemFilter;
      draft.params = action.params;
      draft.selected = action.selected;
      draft.shareIds = [];
      break;
    }
    case SET_FILTER_PARAMS: {
      draft.itemFilter = action.filter;
      draft.shareIds = [];
      break;
    }
    case SET_ATTRIBUTES: {
      draft.attributes = action.attributes;
      break;
    }
    case SET_TERM: {
      draft.term = action.term?.trim();
      draft.shareIds = [];
      break;
    }
    case SET_EXPANDED_CARD: {
      draft.expandedCard = action.card;
      break;
    }
    case RESET_FILTERS: {
      draft.params = [];
      draft.selected = {};
      draft.term = undefined;
      draft.itemFilter = {};
      break;
    }
    case RESET_SELECTION: {
      draft.params = [];
      draft.selected = {};
      break;
    }
    case REMOVE_FILTER: {
      const depthCheck = draft.params.find((param: any) => param.pimId === action.id);
      if (depthCheck) {
        draft.params = draft.params.filter((param: any) => param.depth < depthCheck.depth);
        draft.selected = draft.params.reduce(
          (previous: any, current: any) => ({
            ...previous,
            [current.depth]: current.pimId,
          }),
          {},
        );
      }
      break;
    }
    case SET_SELECTED: {
      if (draft.selected[action.depth] === action.id) {
        delete draft.selected[action.depth];
      } else {
        draft.selected[action.depth] = action.id;
      }
      Object.keys(draft.selected).forEach((depth) => {
        if (depth > action.depth) {
          delete draft.selected[Number(depth)];
        }
      });
      draft.params = Object.entries(draft.selected).map(([depth, pimId]) => ({
        depth: parseInt(depth, 10),
        pimId,
      }));
      draft.shareIds = [];
      break;
    }
    case UPDATE_TOAST: {
      draft.showToast = action.showToast;
      draft.message = action.message || '';
      break;
    }
    case BOOKMARKS_SET: {
      draft.bookmarks = action.bookmarks;
      setBookmarkCount(action.bookmarks.length);
      break;
    }
    case ADD_BOOKMARK_ITEM: {
      draft.bookmarks = draft.bookmarks.concat(action.bookmark);
      setBookmarkCount(draft.bookmarks.length);
      window.localStorage.setItem(PINNED_STORAGE_KEY, JSON.stringify(draft.bookmarks));
      break;
    }
    case REMOVE_BOOKMARK_ITEM: {
      draft.bookmarks = draft.bookmarks.filter((item) => item.id !== action.id);
      setBookmarkCount(draft.bookmarks.length);
      window.localStorage.setItem(PINNED_STORAGE_KEY, JSON.stringify(draft.bookmarks));
      break;
    }
    case REMOVE_BOOKMARK_GROUP: {
      draft.bookmarks = draft.bookmarks.filter((item) => item.group !== action.group);
      setBookmarkCount(draft.bookmarks.length);
      window.localStorage.setItem(PINNED_STORAGE_KEY, JSON.stringify(draft.bookmarks));
      break;
    }
    case SET_LOGIN_STATUS: {
      draft.loggedIn = action.loggedIn;
      break;
    }
    case SET_AVAILABLE_FILTERS: {
      draft.availableFilters = action.value;
      break;
    }
  }

  syncWithUrl(draft);
}, initialResultsState);
